import { jsx as _jsx } from "react/jsx-runtime";
import { Box, Text } from "native-base";
import { timeGridStamp, timeGridStamps } from "./useStyles";
export default function TimeStamps({ timeData, slot = { x: 0 }, }) {
    const { timeCoords = [{ x: 0, text: "" }] } = timeData;
    return (_jsx(Box, Object.assign({ width: slot.x, style: timeGridStamps }, { children: timeCoords.map(({ x, text }, i) => (_jsx(Text, Object.assign({ left: `${x}px`, style: timeGridStamp }, { children: text }), `${i}` + `${x}` + `${text}`))) })));
}
